import React from "react";
import { usePageMetadata } from "./hooks/usePageMetadata";
import { ReadingProgress } from "./components/ReadingProgress";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { ValueStrip } from "./components/ValueStrip";
import { Problems } from "./components/Problems";
import { Bridge } from "./components/Bridge";
import { ProductShowcase } from "./components/ProductShowcase";
import { Tomos } from "./components/Tomos";
import { PreviewGallery } from "./components/PreviewGallery";
import { Bonuses } from "./components/Bonuses";
import { OfferTransition } from "./components/OfferTransition";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
export function App() {
  usePageMetadata("Pequeños Pasos, Grandes Logros | Guías prácticas para acompañar", "Colección digital de 6 guías con herramientas prácticas para rutinas, emociones, atención, aprendizaje, comunicación y acompañamiento cotidiano.");
  return <div className="w-full overflow-x-hidden bg-white text-[var(--ink)]" data-id="element-0" data-mp="3mj6j3vjtnyfg">
      <MetaPixel data-id="element-1" data-mp="3rd1all5o5hp3" />
      <ReadingProgress data-id="element-2" data-mp="3relumgucxi8p" />

      <main className="w-full" data-id="element-3" data-mp="5opww5kum4f">
        <Hero data-id="element-4" data-mp="4n5i12o8na1" />
        <ValueStrip data-id="element-5" data-mp="56nfhsbnbo2" />
        <Problems data-id="element-6" data-mp="7svdij4jt6t" />
        <Bridge data-id="element-7" data-mp="2zld2xbxu5jcl" />
        <ProductShowcase data-id="element-8" data-mp="2zlv6yuqqp1v2" />
        <Tomos data-id="element-9" data-mp="2zmo557bmuj1l" />
        <PreviewGallery data-id="element-10" data-mp="2zmwl5831y4h0" />
        <Bonuses data-id="element-11" data-mp="33mowttnqsqql" />
        <OfferTransition data-id="element-12" data-mp="33m5c656pjo8v" />
        <Offer data-id="element-13" data-mp="33nggc642ey0i" />
        <Guarantee data-id="element-14" data-mp="33mymth8sexwa" />
        <FAQ data-id="element-15" data-mp="33oi1j3esp0vy" />
        <FinalCTA data-id="element-16" data-mp="38m1g64fenfof" />
      </main>

      <Footer data-id="element-17" data-mp="38kqb81a841vq" />
    </div>;
}